import { render, staticRenderFns } from "./SelectedSector.vue?vue&type=template&id=972b8aca&scoped=true&"
import script from "./SelectedSector.vue?vue&type=script&lang=js&"
export * from "./SelectedSector.vue?vue&type=script&lang=js&"
import style0 from "./SelectedSector.vue?vue&type=style&index=0&id=972b8aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972b8aca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VList,VListItem,VSubheader})
